import * as yup from "yup";
import { Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../../../components/ui/button";
import Common from "../../../../helper/common";
import { FormikInput } from "../../../../components/formik-components";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../../../components/ui/dialog";
import { respEnum } from "../../../../constants/appConstant";

const FormikInitialValues = {
  gl_bank_marc: "",
  gl_bank_disc: "",
};

const formikValidation = yup.object({
  gl_bank_marc: yup.string().nullable(),
  gl_bank_disc: yup.string().nullable(),
});

const UpdateGLFields = ({ id, onClose, open, setOpen }) => {
  const formikRef = useRef();
  const dialogRef = useRef();
  const [isFormikInitialized, setIsFormikInitialized] = useState(false);
  const [posMachineName, setPosMachineName] = useState("");

  useEffect(() => {
    setIsFormikInitialized(open);
  }, [open]);

  const onSubmitData = async (d, action) => {
    let data = {
      id: id,
      gl_bank_marc: d.gl_bank_marc || null,
      gl_bank_disc: d.gl_bank_disc || null,
    };
    let response = await Common.ApiService.getInstance().request(
      "UpdatePOSMachineGLFields",
      data,
      "POST"
    );
    action.setSubmitting(false);
    if (response.status === respEnum.Success) {
      Common.SweetAlert.alert(response.message || "GL Fields Updated Successfully", "success");
      onClose?.(response.data);
      setOpen(false);
    } else {
      Common.SweetAlert.alert(response.message || "Failed to update GL Fields", "error");
    }
  };

  const getDataInfo = async () => {
    const payload = { pageNumber: 1, recordsToDisplay: 1000 };
    let response = await Common.ApiService.getInstance().request(
      "GetPOSMachines",
      payload,
      "POST"
    );
    if (Array.isArray(response?.data) && response.data.length > 0) {
      const list = response.data[0]?.data ?? [];
      const current = list.find((x) => x.id === id);
      if (current) {
        setPosMachineName(current.name);
        formikRef.current.setValues({
          gl_bank_marc: current.gl_bank_marc || "",
          gl_bank_disc: current.gl_bank_disc || "",
        });
      }
    }
  };

  useEffect(() => {
    if (id && open) {
      getDataInfo();
    }
  }, [id, open]);

  return (
    <div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          ref={dialogRef}
          className="max-h-[100vh] overflow-y-auto sm:max-w-[500px]"
        >
          <DialogHeader>
            <DialogTitle className="text-base font-medium">
              Update GL Fields - {posMachineName}
            </DialogTitle>
          </DialogHeader>

          <div className="text-sm text-default-500 space-y-2">
            <Formik
              innerRef={formikRef}
              onSubmit={onSubmitData}
              initialValues={FormikInitialValues}
              validationSchema={formikValidation}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(formikProps) => (
                <div className="flex flex-col gap-4">
                  <FormikInput
                    formikProps={formikProps}
                    name={"gl_bank_marc"}
                    label={"GL Bank MARC"}
                    placeholder={"Enter GL Bank MARC"}
                  />

                  <FormikInput
                    formikProps={formikProps}
                    name={"gl_bank_disc"}
                    label={"GL Bank DISC"}
                    placeholder={"Enter GL Bank DISC"}
                  />
                </div>
              )}
            </Formik>
          </div>

          <DialogFooter className="mt-6">
            <DialogClose asChild>
              <Button type="button" variant="outline">
                Close
              </Button>
            </DialogClose>
            {isFormikInitialized && formikRef.current && (
              <Button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  formikRef.current?.handleSubmit();
                }}
              >
                {formikRef.current.isSubmitting
                  ? "Updating..."
                  : "Update"}
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default UpdateGLFields;

